import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';

const ProductInfo = ({product_data}) => {
  const { kreditbetrag, rate, laufzeit, sollzins, fixlaufzeit, description, bag, grundbuch } = product_data;
const formatEuroNumber = (value) => {
  return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

  return (
      <div className="container" id="product_info" style={{paddingLeft:'40px', paddingRight: '40px', paddingBottom: '40px', paddingTop: '10px'}}>
          <div className="row">
          <hr style={{marginTop: '5px'}}/>
            <div className="col-md-6" style={{paddingRight: '10px'}}>
            <b>Individuelles Beispiel</b><br />
            Die Konditionen für das individuelle Beispiel lägen unter Berücksichtigung der zu Grunde liegenden Sollzinsbindung und Annahmen mit Stand 07.03.2024 bei:<br /><br />

            <b>Gesamtkreditbetrag (tatsächlicher Auszahlungsbetrag):</b><br />
            {formatEuroNumber(kreditbetrag)} €<br />
            <b>Kreditlaufzeit:</b><br />
            {laufzeit/12} Jahre<br />
            <b>Anzahl monatlicher Pauschalraten:</b><br />
            {laufzeit}<br />
            <b>Monatliche Kreditrate:</b><br />
            {formatEuroNumber(rate)} €<br />
            <b>Sollzinssatz:</b><br />
            {sollzins.toFixed(3)}% p.A.<br />
            {/*TODO: Echte Werte oder WEG*/}
            <b>Sollzinsbindung:</b><br />
            {fixlaufzeit ? "FIX "+fixlaufzeit/12 : "variabel"}<br />
            <b>Grundbuchseintragungsgebühr:</b><br />
            {formatEuroNumber(grundbuch)} €<br />
            <b>Bearbeitungsgebühr:</b><br />
            {formatEuroNumber(bag)} %<br />
            {/*
            <b>Eingabegebühr:</b><br />
            62,00 €<br />
            <b>Notargebühr:</b><br />
            186,62 €<br />
            <b>Grundbuchsprüfung:</b><br />
            20,00 €<br />
            <b>Kontoführungsentgelt pro 3 Monate:</b><br />
            15,00 €<br />
            <b>Kreditbetrag:</b><br />
            261.875,91 €<br />
            <b>Effektiver Jahreszinssatz:</b><br />
            5,405% p.a.<br />
            <b>Zu zahlender Gesamtbetrag:</b><br />
            548.499,65 €<br />*/}
            </div>
            <div className="col-md-6">
            <p>Es handelt sich bei den vorliegenden Informationen nicht um eine Europäische Standardinformation für Kredite (ESIS Merkblatt) gemäß § 8 Hypothekar- und Immobilienkreditgesetz (HIKrG) und auch um kein verbindliches Angebot im Sinne des §12 HIKrG.</p>

            <p>Das nebenstehende Finanzierungsbeispiel ersetzt keine persönliche Beratung und beruht auf Annahmen. Der Zinssatz und die monatliche Rate sind bonitätsabhängig und können erst nach eingehender Prüfung durch das Kreditinstitut festgelegt werden. Zum jetzigen Zeitpunkt ist die Höhe der Kosten im Zusammenhang mit dem Kredit noch nicht im Detail bekannt. Sofern sonstige Kosten anfallen, die der Antragsteller im Zusammenhang mit dem Kreditvertrag zu tragen hat, erhöht sich der effektive Jahreszinssatz.</p>

            <p><b>Hinweis:</b> Ein Kredit kann durch ein Kreditinstitut nicht gewährt werden, wenn der Kreditgeber nicht imstande ist, eine Kreditwürdigkeitsprüfung vorzunehmen, weil sich der Verbraucher weigert, die für die Prüfung seiner Kreditwürdigkeit erforderlichen Informationen oder Nachweise vorzulegen.</p>

            <b>Annahmen</b>
            <ul>
            <li>Gültig bei erstrangiger Besicherung des Darlehens über eine Hypothek</li>
            <li>Einwandfreie Einkommens- und Vermögenverhältnisse vorausgesetzt</li>
            <li>Auszahlung des Kreditbetrages in einer Summe</li>
            </ul>
            <p><b>Datenschutz</b><br />Ihre Daten werden streng vertraulich behandelt  und nicht an Dritte weitergegeben, Details dazu finden Sie in unserer Datenschutzerklärung. </p>
            </div>
        </div>
      </div>
  );
};

export default ProductInfo;
